module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-box text-center"
  }, [(_vm.storeInfo.brand_name) ? _c('h1', {
    staticStyle: {
      "position": "absolute",
      "top": "-57px",
      "left": "90px",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.storeInfo.brand_name) + " - " + _vm._s(_vm.storeInfo.name_short))]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.storeMethod == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 1
      }
    }
  }, [_c('a', [_vm._v("基本資訊")])]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 2
      }
    }
  }, [_c('a', [_vm._v("細部設定")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 3
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 3
      }
    }
  }, [_c('a', [_vm._v("預訂/訂購時間")])]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 4
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 4
      }
    }
  }, [_c('a', [_vm._v("付款方式")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 5
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 5
      }
    }
  }, [_c('a', [_vm._v("製作/取餐時間")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 6
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 6
      }
    }
  }, [_c('a', [_vm._v("取餐方式/門檻")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 7
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 7
      }
    }
  }, [_c('a', [_vm._v("營業/公休時間")])]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 8
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 8
      }
    }
  }, [_c('a', [_vm._v("塑膠袋")])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 && _vm.getRestricted.indexOf(900) !== -1) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 12
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 12
      }
    }
  }, [_c('a', [_vm._v("計費方式設定")])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 13
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 13
      }
    }
  }, [_c('a', [_vm._v("物流設定")])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 15
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 15
      }
    }
  }, [_c('a', [_vm._v("特殊需求")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        return _vm.clearPage()
      }
    }
  }, [_vm._v("\n            清空此頁面設定\n          ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 1),
      expression: "storeMethod === 1"
    }],
    staticClass: "box-body form"
  }, [_c('h3', [_vm._v("店家資訊")]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              店家公吿設定\n              "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block pt-5"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.removeComment),
      expression: "removeComment"
    }],
    attrs: {
      "type": "radio",
      "name": "removeComment"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.removeComment, false)
    },
    on: {
      "change": function($event) {
        _vm.removeComment = false
      }
    }
  }), _vm._v("編輯店家公告\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.removeComment),
      expression: "removeComment"
    }],
    attrs: {
      "type": "radio",
      "name": "removeComment"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.removeComment, true)
    },
    on: {
      "change": function($event) {
        _vm.removeComment = true
      }
    }
  }), _vm._v("清空現有店家公告\n                  ")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [(!_vm.removeComment && _vm.removeComment != null) ? _c('div', {
    staticClass: "input-group m-t-25"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              店家公告\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.comment),
      expression: "storeInfo.comment"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.storeInfo.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "comment", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group m-t-5"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              餐點種類\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "tag-placeholder": "餐點種類",
      "placeholder": "餐點種類",
      "label": "label",
      "track-by": "value",
      "options": _vm.mealTagList,
      "multiple": true
    },
    model: {
      value: (_vm.storeInfo.binding_meal_tag_ids),
      callback: function($$v) {
        _vm.$set(_vm.storeInfo, "binding_meal_tag_ids", $$v)
      },
      expression: "storeInfo.binding_meal_tag_ids"
    }
  })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              描述\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.description),
      expression: "storeInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.storeInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              描述(搜尋引擎顯示)\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.search_description),
      expression: "storeInfo.search_description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.storeInfo.search_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "search_description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              品牌頁介紹\n            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.introduction),
      expression: "storeInfo.introduction"
    }],
    staticClass: "w-100-p form-control",
    attrs: {
      "name": "introduction",
      "cols": "30",
      "rows": "10",
      "maxlength": "65535"
    },
    domProps: {
      "value": (_vm.storeInfo.introduction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "introduction", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group m-t-5"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              Youtube 影片代碼\n            ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.youtube_video_code),
      expression: "storeInfo.youtube_video_code"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.storeInfo.youtube_video_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "youtube_video_code", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              肉品產地說明\n            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.meat_origin_description),
      expression: "storeInfo.meat_origin_description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "maxlength": "500",
      "placeholder": "範例：本店牛肉來源－澳洲 / 豬肉來源－台灣"
    },
    domProps: {
      "value": (_vm.storeInfo.meat_origin_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "meat_origin_description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              LOGO\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.storeInfo.image_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storeInfo.image_name) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.storeInfo.image_name,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [(_vm.imgLogoOption.length) ? _c('div', {
    staticClass: "pull-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgLogoSelect),
      expression: "imgLogoSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.imgLogoSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.imgLogoOption), function(img, index) {
    return _c('option', {
      domProps: {
        "value": img.name
      }
    }, [_vm._v(_vm._s(img.name))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    class: {
      'm-t-25': !_vm.imgLogoOption.length
    },
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "for": "brand-img-load"
    }
  }, [_vm._v("\n                    選擇圖片\n                  ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-img-load"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                底圖照片\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.storeInfo.photo_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.storeInfo.photo_name) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.storeInfo.photo_name,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "for": "brand-photo-load"
    }
  }, [_vm._v("\n                  選擇圖片\n                ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-photo-load"
    },
    on: {
      "change": _vm.onPhotoFileChange
    }
  })])])]) : _vm._e(), _vm._v(" "), _vm._m(3)]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 2),
      expression: "storeMethod === 2"
    }],
    staticClass: "box-body form"
  }, [_c('div', [_vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.reCheckOption.body) ? _c('div', {
    staticClass: "hint mb-1"
  }, [_c('i', {
    staticClass: "fa fa-close re-check-close",
    on: {
      "click": function($event) {
        _vm.invalidStoreMap = null
      }
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.reCheckOption.body)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                API服務類型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.apiTypeSelect),
      expression: "apiTypeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.apiTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("專屬客製POS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("公版POS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("平板接單")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                營業狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelect),
      expression: "statusSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("尚未營業")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("籌備中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("營業中(上架)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("休息中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("已歇業")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              距離計算模式\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disModeSelect),
      expression: "disModeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.disModeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("走路模式(WALKING)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("開車模式(DRIVING)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v("機車(SCOOTER)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("大眾運輸(TRANSIT)")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            條碼類型\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.barcodeSelect),
      expression: "barcodeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.barcodeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("不支援")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("一維條碼")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("二維條碼(QRcode)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("一維、二維都支援")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                金額進位\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.roundingTypeSelect),
      expression: "roundingTypeSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.roundingTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("無條件進位")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("無條件捨去")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("四捨五入")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("保留小數點")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                優惠券形式\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.couponFormSelect),
      expression: "couponFormSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.couponFormSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("依付款方式使用優惠券")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("依虛擬商品使用優惠券")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                自訂設定顯示方式\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProdSettingSelect),
      expression: "showProdSettingSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.showProdSettingSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("別名跟描述不顯示")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("別名跟描述都顯示")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("只顯示別名")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("只顯示描述")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon b-r"
  }, [_vm._v("\n              開放紙本發票\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoicePaperSelect),
      expression: "hasInvoicePaperSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoicePaperOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.hasInvoicePaperSelect, 1)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoicePaperSelect = 1
      }
    }
  }), _vm._v("開放\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoicePaperSelect),
      expression: "hasInvoicePaperSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoicePaperOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.hasInvoicePaperSelect, 0)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoicePaperSelect = 0
      }
    }
  }), _vm._v("停用\n                  ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon b-r"
  }, [_vm._v("\n                開放電子載具\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoiceCarrierSelect),
      expression: "hasInvoiceCarrierSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceCarrierOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.hasInvoiceCarrierSelect, 1)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoiceCarrierSelect = 1
      }
    }
  }), _vm._v("開放 (請確認POS端是否支援此功能)\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoiceCarrierSelect),
      expression: "hasInvoiceCarrierSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceCarrierOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.hasInvoiceCarrierSelect, 0)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoiceCarrierSelect = 0
      }
    }
  }), _vm._v("停用\n                  ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                發票備註\n              ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceRemark),
      expression: "invoiceRemark"
    }],
    staticClass: "w-100-p form-control",
    attrs: {
      "name": "invoiceRemark",
      "cols": "30",
      "rows": "3",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.invoiceRemark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invoiceRemark = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.invoiceRemark ? _vm.invoiceRemark.length : 0) + "/100")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon b-r"
  }, [_vm._v("\n              開放愛心捐贈發票\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoiceNpobnaSelect),
      expression: "hasInvoiceNpobnaSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceNpobnaOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.hasInvoiceNpobnaSelect, 1)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoiceNpobnaSelect = 1
      }
    }
  }), _vm._v("開放\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasInvoiceNpobnaSelect),
      expression: "hasInvoiceNpobnaSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceNpobnaOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.hasInvoiceNpobnaSelect, 0)
    },
    on: {
      "change": function($event) {
        _vm.hasInvoiceNpobnaSelect = 0
      }
    }
  }), _vm._v("停用\n                  ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon b-r"
  }, [_vm._v("\n              店家是否開立發票\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isInvoiceException),
      expression: "isInvoiceException"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceException",
      "disabled": _vm.allInvoiceClosed
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.isInvoiceException, 0)
    },
    on: {
      "change": function($event) {
        _vm.isInvoiceException = 0
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'radio-text--disabled': _vm.allInvoiceClosed
    }
  }, [_vm._v("\n                      開發票\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isInvoiceException),
      expression: "isInvoiceException"
    }],
    attrs: {
      "type": "radio",
      "name": "invoiceException",
      "disabled": _vm.hasInvoiceSelected
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.isInvoiceException, 1)
    },
    on: {
      "change": function($event) {
        _vm.isInvoiceException = 1
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'radio-text--disabled': _vm.hasInvoiceSelected
    }
  }, [_vm._v("\n                      免開發票\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            前端顯示此店家\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isVisibleSelect),
      expression: "isVisibleSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "showOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.isVisibleSelect, "1")
    },
    on: {
      "change": function($event) {
        _vm.isVisibleSelect = "1"
      }
    }
  }), _vm._v("顯示\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isVisibleSelect),
      expression: "isVisibleSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "showOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.isVisibleSelect, "0")
    },
    on: {
      "change": function($event) {
        _vm.isVisibleSelect = "0"
      }
    }
  }), _vm._v("隱藏\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                首頁是否搜尋的到店家\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSearchSelect),
      expression: "isSearchSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "searchOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.isSearchSelect, "1")
    },
    on: {
      "change": function($event) {
        _vm.isSearchSelect = "1"
      }
    }
  }), _vm._v("是\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSearchSelect),
      expression: "isSearchSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "searchOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.isSearchSelect, "0")
    },
    on: {
      "change": function($event) {
        _vm.isSearchSelect = "0"
      }
    }
  }), _vm._v("否\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              支援客製餐點貼紙\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isStickerSelect),
      expression: "isStickerSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "stickerOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.isStickerSelect, 1)
    },
    on: {
      "change": function($event) {
        _vm.isStickerSelect = 1
      }
    }
  }), _vm._v("支援 (請確認POS端是否支援此功能)\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isStickerSelect),
      expression: "isStickerSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "stickerOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.isStickerSelect, 0)
    },
    on: {
      "change": function($event) {
        _vm.isStickerSelect = 0
      }
    }
  }), _vm._v("不支援\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number.lazy.trim",
      value: (_vm.storeInfo.custom_sticker_max_length),
      expression: "storeInfo.custom_sticker_max_length",
      modifiers: {
        "number": true,
        "lazy": true,
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "僅可輸入數字，最多10字",
      "type": "number",
      "min": "1",
      "max": "10"
    },
    domProps: {
      "value": (_vm.storeInfo.custom_sticker_max_length)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.storeInfo, "custom_sticker_max_length", _vm._n($event.target.value.trim()))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon b-r"
  }, [_c('span', [_vm._v("強制阻擋外送門檻")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                  若選擇強制阻擋外送門檻，消費者訂購時必須符合「取餐方式/門檻-消費金額與距離門檻」的設定才可下單。注意 : 無論是否強制阻擋外送門檻，外送訂單均須符合最低金額門檻才可下單。\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.delivery_stage_limit_type),
      expression: "storeInfo.delivery_stage_limit_type"
    }],
    attrs: {
      "type": "radio",
      "name": "deliveryStageLimit"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.delivery_stage_limit_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "delivery_stage_limit_type", 1)
      }
    }
  }), _vm._v("不強制\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.delivery_stage_limit_type),
      expression: "storeInfo.delivery_stage_limit_type"
    }],
    attrs: {
      "type": "radio",
      "name": "deliveryStageLimit"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.storeInfo.delivery_stage_limit_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "delivery_stage_limit_type", 2)
      }
    }
  }), _vm._v("強制\n                  ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon b-r"
  }, [_vm._v("\n              單品備註\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_support_custom_remark),
      expression: "storeInfo.is_support_custom_remark"
    }],
    attrs: {
      "type": "radio",
      "name": "customRemark"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.is_support_custom_remark, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_support_custom_remark", 1)
      }
    }
  }), _vm._v("開啟 (請確認POS端是否支援此功能)\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_support_custom_remark),
      expression: "storeInfo.is_support_custom_remark"
    }],
    attrs: {
      "type": "radio",
      "name": "customRemark"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.is_support_custom_remark, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_support_custom_remark", 0)
      }
    }
  }), _vm._v("停用\n                  ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            單筆訂單最高上限(單位:元)\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.one_order_max_money),
      expression: "storeInfo.one_order_max_money"
    }],
    ref: "oneOrderMaxMoney",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.storeInfo.one_order_max_money)
    },
    on: {
      "keyup": _vm.verityOneOrderMaxMoney,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "one_order_max_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            菜單版型\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_layout_type),
      expression: "storeInfo.menu_layout_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.storeInfo, "menu_layout_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.menuLayout), function(layout) {
    return _c('option', {
      domProps: {
        "value": layout.value
      }
    }, [_vm._v(_vm._s(layout.label))])
  }), 0)])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            飲料溫度顯示(冷 熱 無溫度)\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showMenuIconSelect),
      expression: "showMenuIconSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.showMenuIconSelect, "0")
    },
    on: {
      "change": function($event) {
        _vm.showMenuIconSelect = "0"
      }
    }
  }), _vm._v("全部顯示\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showMenuIconSelect),
      expression: "showMenuIconSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.showMenuIconSelect, "1")
    },
    on: {
      "change": function($event) {
        _vm.showMenuIconSelect = "1"
      }
    }
  }), _vm._v("無溫度顯示冷\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showMenuIconSelect),
      expression: "showMenuIconSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.showMenuIconSelect, "2")
    },
    on: {
      "change": function($event) {
        _vm.showMenuIconSelect = "2"
      }
    }
  }), _vm._v("皆顯示無溫度\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            菜單產品圖示顯示\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.show_menu_product_icon),
      expression: "storeInfo.show_menu_product_icon"
    }],
    attrs: {
      "type": "radio",
      "name": "prodIconOption"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.show_menu_product_icon, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "show_menu_product_icon", 1)
      }
    }
  }), _vm._v("顯示\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.show_menu_product_icon),
      expression: "storeInfo.show_menu_product_icon"
    }],
    attrs: {
      "type": "radio",
      "name": "prodIconOption"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.show_menu_product_icon, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "show_menu_product_icon", 0)
      }
    }
  }), _vm._v("隱藏\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              菜單選項展開類型\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_expand_type),
      expression: "storeInfo.menu_expand_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuExpandType"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.menu_expand_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_expand_type", 1)
      }
    }
  }), _vm._v("隱藏\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_expand_type),
      expression: "storeInfo.menu_expand_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuExpandType"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.storeInfo.menu_expand_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_expand_type", 2)
      }
    }
  }), _vm._v("展開\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              菜單當日停賣樣式\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_stop_sale_today_type),
      expression: "storeInfo.menu_stop_sale_today_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuStopSaleTodayType"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.menu_stop_sale_today_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_stop_sale_today_type", 1)
      }
    }
  }), _vm._v("顯示當日停賣ICON\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_stop_sale_today_type),
      expression: "storeInfo.menu_stop_sale_today_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuStopSaleTodayType"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.storeInfo.menu_stop_sale_today_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_stop_sale_today_type", 2)
      }
    }
  }), _vm._v("隱藏當日停賣商品\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              菜單永久停賣樣式\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_stop_sale_type),
      expression: "storeInfo.menu_stop_sale_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuStopSaleType"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.menu_stop_sale_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_stop_sale_type", 1)
      }
    }
  }), _vm._v("顯示永久停賣ICON\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_stop_sale_type),
      expression: "storeInfo.menu_stop_sale_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menuStopSaleType"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.storeInfo.menu_stop_sale_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_stop_sale_type", 2)
      }
    }
  }), _vm._v("隱藏永久停賣商品\n                    ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                銷售折扣組合(紅配綠)菜單分類顯示\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    若開啟，菜單分類會再新增「紅區」、「綠區」，提升活動能見度！\n                  ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_ab_block_type),
      expression: "storeInfo.menu_ab_block_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menu_ab_block_type"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.menu_ab_block_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_ab_block_type", 1)
      }
    }
  }), _vm._v("開啟\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.menu_ab_block_type),
      expression: "storeInfo.menu_ab_block_type"
    }],
    attrs: {
      "type": "radio",
      "name": "menu_ab_block_type"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.menu_ab_block_type, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "menu_ab_block_type", 0)
      }
    }
  }), _vm._v("關閉\n                    ")])])])])]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 3),
      expression: "storeMethod === 3"
    }],
    staticClass: "box-body form"
  }, [_vm._m(8), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            開始預訂(距今日幾天，0為當日)\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.order_start_day),
      expression: "storeInfo.order_start_day"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.order_start_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "order_start_day", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            結束預訂(距開始預訂幾天，0為開始預訂日)\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.order_tolerance_day),
      expression: "storeInfo.order_tolerance_day"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.order_tolerance_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "order_tolerance_day", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            自動拒絕預約單時間(單位:分鐘)\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.auto_reject_order_reserve_m),
      expression: "storeInfo.auto_reject_order_reserve_m"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.auto_reject_order_reserve_m)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "auto_reject_order_reserve_m", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            接單狀態\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderStatusSelect),
      expression: "orderStatusSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "orderOption",
      "value": "10"
    },
    domProps: {
      "checked": _vm._q(_vm.orderStatusSelect, "10")
    },
    on: {
      "change": function($event) {
        _vm.orderStatusSelect = "10"
      }
    }
  }), _vm._v("接單中\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderStatusSelect),
      expression: "orderStatusSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "orderOption",
      "value": "20"
    },
    domProps: {
      "checked": _vm._q(_vm.orderStatusSelect, "20")
    },
    on: {
      "change": function($event) {
        _vm.orderStatusSelect = "20"
      }
    }
  }), _vm._v("不接單\n                  ")])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              暫停接單理由\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.order_status_reason),
      expression: "storeInfo.order_status_reason"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.storeInfo.order_status_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "order_status_reason", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            自動拒單時間(單位:分鐘)\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.auto_reject_order_m),
      expression: "storeInfo.auto_reject_order_m"
    }],
    ref: "rejectTime",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.storeInfo.auto_reject_order_m)
    },
    on: {
      "keyup": _vm.verityRejectTime,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "auto_reject_order_m", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            當日訂購時間前下單\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_preparing_allow_order),
      expression: "storeInfo.is_preparing_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isPreparingAllow"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.is_preparing_allow_order, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_preparing_allow_order", 1)
      }
    }
  }), _vm._v("可下單\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_preparing_allow_order),
      expression: "storeInfo.is_preparing_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isPreparingAllow"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.is_preparing_allow_order, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_preparing_allow_order", 0)
      }
    }
  }), _vm._v("不可下單\n                  ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            結束訂購時間後下單\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_close_allow_order),
      expression: "storeInfo.is_close_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isCloseAllow"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.is_close_allow_order, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_close_allow_order", 1)
      }
    }
  }), _vm._v("可下單\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_close_allow_order),
      expression: "storeInfo.is_close_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isCloseAllow"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.is_close_allow_order, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_close_allow_order", 0)
      }
    }
  }), _vm._v("不可下單\n                  ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 4),
      expression: "storeMethod === 4"
    }],
    staticClass: "box-body form"
  }, [_vm._m(10), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("付款類型")]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('td', [_vm._v("支援與否")]) : _vm._e(), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('td', [_vm._v("開啟狀態")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                備註 (顯示在購物車頁面上，消費者可查看)\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(11)], 1)])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tradeInfo), function(tradeType, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(tradeType.name))]), _vm._v(" "), (_vm.getRoleType == 99) ? _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.is_support),
        expression: "tradeType.is_support"
      }],
      attrs: {
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(tradeType.is_support, "1")
      },
      on: {
        "change": function($event) {
          return _vm.$set(tradeType, "is_support", "1")
        }
      }
    }), _vm._v("支援\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.is_support),
        expression: "tradeType.is_support"
      }],
      attrs: {
        "type": "radio",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(tradeType.is_support, "0")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(tradeType, "is_support", "0")
        }, function($event) {
          return _vm.clickClose('tradeType', false, tradeType.is_default, _vm.dIndex)
        }]
      }
    }), _vm._v("不支援\n                    ")])])])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.is_enable),
        expression: "tradeType.is_enable"
      }],
      attrs: {
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(tradeType.is_enable, "1")
      },
      on: {
        "input": _vm.setReload,
        "change": function($event) {
          return _vm.$set(tradeType, "is_enable", "1")
        }
      }
    }), _vm._v("開啟\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.is_enable),
        expression: "tradeType.is_enable"
      }],
      attrs: {
        "type": "radio",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(tradeType.is_enable, "0")
      },
      on: {
        "input": _vm.setReload,
        "change": [function($event) {
          return _vm.$set(tradeType, "is_enable", "0")
        }, function($event) {
          return _vm.clickClose('tradeType', false, tradeType.is_default, _vm.dIndex)
        }]
      }
    }), _vm._v("關閉\n                    ")])])])]) : _vm._e(), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tradeType.remark),
        expression: "tradeType.remark"
      }],
      staticClass: "w-100-p form-control",
      attrs: {
        "rows": "2",
        "maxlength": _vm.remarkMaxlength
      },
      domProps: {
        "value": (tradeType.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(tradeType, "remark", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(tradeType.remark.length || 0) + "/" + _vm._s(_vm.remarkMaxlength))])])])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(13), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("內用-桌邊掃碼")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.is_cash_pay_after_meal),
      expression: "tableNumber.is_cash_pay_after_meal"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.tableNumber.is_cash_pay_after_meal, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tableNumber, "is_cash_pay_after_meal", 0)
      }
    }
  }), _vm._v("\n                        餐前付款\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.is_cash_pay_after_meal),
      expression: "tableNumber.is_cash_pay_after_meal"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.tableNumber.is_cash_pay_after_meal, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tableNumber, "is_cash_pay_after_meal", 1)
      }
    }
  }), _vm._v("\n                        餐後付款\n                      ")])])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addExceptionTrade
    }
  }, [_vm._v("新增限制")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.exceptionTradeList.length) ? _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(15), _vm._v(" "), _c('tbody', _vm._l((_vm.exceptionTradeList), function(exceptionTrade, eIndex) {
    return _c('tr', [_c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exceptionTrade.delivery_type),
        expression: "exceptionTrade.delivery_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(exceptionTrade, "delivery_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.deliveryInfo), function(delivery) {
      return _c('option', {
        domProps: {
          "value": delivery.value
        }
      }, [_vm._v(_vm._s(delivery.label))])
    })], 2)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exceptionTrade.trade_type),
        expression: "exceptionTrade.trade_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(exceptionTrade, "trade_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.tradeList), function(trade) {
      return _c('option', {
        domProps: {
          "value": trade.value
        }
      }, [_vm._v(_vm._s(trade.label))])
    }), 0)]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exceptionTrade.start_money),
        expression: "exceptionTrade.start_money"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (exceptionTrade.start_money)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(exceptionTrade, "start_money", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exceptionTrade.end_money),
        expression: "exceptionTrade.end_money"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (exceptionTrade.end_money)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(exceptionTrade, "end_money", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm._f("deliveryName")(exceptionTrade.delivery_type)) + "\n                  "), (exceptionTrade.start_money) ? _c('span', [_vm._v("\n                    " + _vm._s(exceptionTrade.start_money) + " 元以上\n                  ")]) : _vm._e(), _vm._v(" "), (exceptionTrade.start_money && exceptionTrade.end_money) ? _c('span', [_vm._v("\n                    ～\n                  ")]) : _vm._e(), _vm._v(" "), (exceptionTrade.end_money) ? _c('span', [_vm._v("\n                    " + _vm._s(exceptionTrade.end_money) + " 元以下\n                  ")]) : _vm._e(), _vm._v("\n                  不可用" + _vm._s(_vm._f("tradeName")(exceptionTrade.trade_type)) + "付款\n                ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.exceptionTradeList, eIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 5),
      expression: "storeMethod === 5"
    }],
    staticClass: "box-body form"
  }, [_vm._m(16), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(18), _vm._v(" "), _c('tbody', _vm._l((_vm.takeTimeInfo), function(takeTime) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.hideDeliveryType.includes(takeTime.take_type)),
        expression: "!hideDeliveryType.includes(takeTime.take_type)"
      }]
    }, [_c('td', [_vm._v(_vm._s(_vm._f("deliveryName")(takeTime.take_type)))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (takeTime.prepare_time_seg),
        expression: "takeTime.prepare_time_seg"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (takeTime.prepare_time_seg)
      },
      on: {
        "keypress": _vm.returnNum,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(takeTime, "prepare_time_seg", $event.target.value)
        }
      }
    }), _vm._v("  分鐘\n              ")]), _vm._v(" "), _c('td', [(takeTime.take_type < 3) ? _c('span', [_vm._v("不需設定")]) : (takeTime.take_type === 21) ? _c('span', [_vm._v("不需設定")]) : _c('div', {
      staticClass: "flex align-center"
    }, [_c('div', {
      staticClass: "input-group-btn flex w-auto"
    }, [_c('button', {
      staticClass: "btn btn-default w-36px",
      attrs: {
        "disabled": !takeTime.take_time_seg
      },
      on: {
        "click": function($event) {
          return _vm.setTakeTime('minus', takeTime)
        }
      }
    }, [_vm._v("\n                      -\n                    ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (takeTime.take_time_seg),
        expression: "takeTime.take_time_seg"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (takeTime.take_time_seg)
      },
      on: {
        "keypress": _vm.returnNum,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(takeTime, "take_time_seg", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default w-36px",
      on: {
        "click": function($event) {
          return _vm.setTakeTime('add', takeTime)
        }
      }
    }, [_vm._v("\n                      +\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "m-l-5"
    }, [_vm._v("分鐘")])])])])
  }), 0)])]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', {
    staticClass: "text-left"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addProcessTime
    }
  }, [_vm._v("新增某時段的製作時間")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.processTimeList), function(process, pIndex) {
    return _c('div', {
      staticClass: "m-t-10 process-time-block"
    }, [_c('div', {
      staticClass: "text-right m-b-10"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.processTimeList, pIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n              月份\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "新增月份",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.month,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.month),
        callback: function($$v) {
          _vm.$set(process, "month", $$v)
        },
        expression: "process.month"
      }
    })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("時間類型")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (process.value_type),
        expression: "process.value_type"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(process, "value_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.clearProcess(process)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("日期")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2
      }
    }, [_vm._v("星期")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (process.value_type === 2) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n              開始\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "新增星期",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.weekDay,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.start_value),
        callback: function($$v) {
          _vm.$set(process, "start_value", $$v)
        },
        expression: "process.start_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n              開始\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "tag-placeholder": "數字為1~31",
        "placeholder": "新增日期 (格式為數字1~31)",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.monthDay,
        "multiple": false,
        "taggable": true,
        "id": 'process-start-' + pIndex
      },
      on: {
        "tag": _vm.addStartMonthDayTag
      },
      model: {
        value: (process.start_value),
        callback: function($$v) {
          _vm.$set(process, "start_value", $$v)
        },
        expression: "process.start_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 2) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n              結束\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "新增星期",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.weekDay,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.end_value),
        callback: function($$v) {
          _vm.$set(process, "end_value", $$v)
        },
        expression: "process.end_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (process.value_type === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n              結束\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "tag-placeholder": "數字為1~31",
        "placeholder": "新增日期 (格式為數字1~31)",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.monthDay,
        "multiple": false,
        "taggable": true
      },
      on: {
        "tag": _vm.addEndMonthDayTag
      },
      model: {
        value: (process.end_value),
        callback: function($$v) {
          _vm.$set(process, "end_value", $$v)
        },
        expression: "process.end_value"
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n              取餐類型\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "選擇取餐類型",
        "label": "label",
        "track-by": "value",
        "options": _vm.deliveryTypeOption,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (process.delivery_type),
        callback: function($$v) {
          _vm.$set(process, "delivery_type", $$v)
        },
        expression: "process.delivery_type"
      }
    })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addItemTime(process)
        }
      }
    }, [_vm._v("加入時間")])]), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(19, true), _vm._v(" "), _c('tbody', _vm._l((process.item_list), function(item, iIndex) {
      return _c('tr', [_c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.process_time),
          expression: "item.process_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "",
          "type": "text"
        },
        domProps: {
          "value": (item.process_time)
        },
        on: {
          "keypress": _vm.returnNum,
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "process_time", $event.target.value)
          }
        }
      }), _vm._v("  分鐘\n              ")]), _vm._v(" "), _c('td', [(iIndex > 0) ? _c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(process.item_list, iIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })]) : _vm._e()])])
    }), 0)])])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 6),
      expression: "storeMethod === 6"
    }],
    staticClass: "box-body form"
  }, [_vm._m(20), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), (_vm.reCheckOption.body) ? _c('div', {
    staticClass: "hint mb-1"
  }, [_c('i', {
    staticClass: "fa fa-close re-check-close",
    on: {
      "click": function($event) {
        _vm.invalidStoreMap = null
      }
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.reCheckOption.body)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐類型")]), _vm._v(" "), (_vm.getRoleType == 99) ? _c('td', [_vm._v("支援與否")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("開啟狀態")]), _vm._v(" "), _c('td', [_vm._v("\n                預設\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n                    購物車預設的取餐方式。開啟狀態為 \"開啟\" 的取餐方式才能設為預設。\n                  ")])], 1)]), _vm._v(" "), _c('td', [_c('span', [_vm._v("消費金額與距離門檻")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(24)], 1)]), _vm._v(" "), _c('td', [_c('span', [_vm._v("備註")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(25)], 1)]), _vm._v(" "), _c('td', [_c('span', [_vm._v("取餐提醒")]), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(26)], 1)])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.deliveryWaysInfo), function(deliveryWays, dIndex) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.hideDeliveryType.includes(deliveryWays.take_type)),
        expression: "!hideDeliveryType.includes(deliveryWays.take_type)"
      }],
      key: dIndex
    }, [_c('td', [_vm._v(_vm._s(_vm._f("deliveryName")(deliveryWays.take_type)))]), _vm._v(" "), (_vm.getRoleType == 99) ? _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_support),
        expression: "deliveryWays.is_support"
      }],
      attrs: {
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_support, "1")
      },
      on: {
        "change": function($event) {
          return _vm.$set(deliveryWays, "is_support", "1")
        }
      }
    }), _vm._v("\n                      支援\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_support),
        expression: "deliveryWays.is_support"
      }],
      attrs: {
        "type": "radio",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_support, "0")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(deliveryWays, "is_support", "0")
        }, function($event) {
          return _vm.clickClose('deliveryWays', true, deliveryWays.is_default, dIndex)
        }]
      }
    }), _vm._v("\n                      不支援\n                    ")])])])]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_enable),
        expression: "deliveryWays.is_enable"
      }],
      attrs: {
        "type": "radio",
        "disabled": parseInt(deliveryWays.is_support, 10) === 0,
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_enable, "1")
      },
      on: {
        "change": function($event) {
          return _vm.$set(deliveryWays, "is_enable", "1")
        }
      }
    }), _vm._v(" "), _c('span', {
      class: {
        'radio-text--disabled': deliveryWays.is_support == 0
      }
    }, [_vm._v("\n                          開啟\n                        ")])])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_enable),
        expression: "deliveryWays.is_enable"
      }],
      attrs: {
        "type": "radio",
        "value": "0",
        "disabled": parseInt(deliveryWays.is_support, 10) === 0
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_enable, "0")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(deliveryWays, "is_enable", "0")
        }, function($event) {
          return _vm.clickClose('deliveryWays', false, deliveryWays.is_default, dIndex)
        }]
      }
    }), _vm._v(" "), _c('span', {
      class: {
        'radio-text--disabled': deliveryWays.is_support == 0
      }
    }, [_vm._v("\n                          關閉\n                        ")])])])])]), _vm._v(" "), _c('td', [(deliveryWays.take_type !== 21) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_default),
        expression: "deliveryWays.is_default"
      }],
      attrs: {
        "type": "radio",
        "value": "1",
        "disabled": parseInt(deliveryWays.is_support, 10) === 0 || parseInt(deliveryWays.is_enable, 10) === 0
      },
      domProps: {
        "checked": _vm._q(deliveryWays.is_default, "1")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(deliveryWays, "is_default", "1")
        }, function($event) {
          return _vm.checkDefault(deliveryWays.take_type)
        }]
      }
    })]) : _vm._e()]), _vm._v(" "), (deliveryWays.take_type !== 3) ? _c('td', [_vm._v("\n                滿  "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.price),
        expression: "deliveryWays.price"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (deliveryWays.price)
      },
      on: {
        "keypress": _vm.returnNum,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(deliveryWays, "price", $event.target.value)
        }
      }
    }), _vm._v("  元即可" + _vm._s(_vm._f("deliveryName")(deliveryWays.take_type)) + "\n              ")]) : _vm._e(), _vm._v(" "), (deliveryWays.take_type === 3) ? _c('td', [_c('delivery-limit', {
      attrs: {
        "store-info": _vm.storeInfo,
        "delivery-ways": deliveryWays,
        "delivery-ways-info": _vm.deliveryWaysInfo,
        "delivery-other": _vm.deliveryOther
      },
      on: {
        "update:deliveryWaysInfo": function($event) {
          _vm.deliveryWaysInfo = $event
        },
        "update:deliveryOther": function($event) {
          _vm.deliveryOther = $event
        },
        "update:storeInfo": function($event) {
          _vm.storeInfo = $event
        },
        "update:deliveryWays": function($event) {
          deliveryWays = $event
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.memo),
        expression: "deliveryWays.memo"
      }],
      staticClass: "w-100-p form-control",
      attrs: {
        "rows": "2",
        "maxlength": _vm.remarkMaxlength
      },
      domProps: {
        "value": (deliveryWays.memo)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(deliveryWays, "memo", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(deliveryWays.memo ? deliveryWays.memo.length : 0) + "/" + _vm._s(_vm.remarkMaxlength))])]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.pickup_memo),
        expression: "deliveryWays.pickup_memo"
      }],
      staticClass: "w-100-p form-control",
      attrs: {
        "disabled": _vm.getRoleType === 10 && deliveryWays.is_support === 0,
        "rows": "2",
        "maxlength": _vm.remarkMaxlength
      },
      domProps: {
        "value": (deliveryWays.pickup_memo)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(deliveryWays, "pickup_memo", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(deliveryWays.pickup_memo ? deliveryWays.pickup_memo.length : 0) + "/" + _vm._s(_vm.remarkMaxlength))])])])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('shipping-form', {
    ref: "shippingInfo",
    attrs: {
      "store-info": _vm.storeInfo,
      "resetShopping": _vm.resetShopping
    },
    on: {
      "update:store-info": function($event) {
        _vm.storeInfo = $event
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h3', [_vm._v("桌號設定")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              送餐方式\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.sub_delivery_type),
      expression: "tableNumber.sub_delivery_type"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.tableNumber.sub_delivery_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tableNumber, "sub_delivery_type", 1)
      }
    }
  }), _vm._v("\n                    叫號取餐\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.sub_delivery_type),
      expression: "tableNumber.sub_delivery_type"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.tableNumber.sub_delivery_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tableNumber, "sub_delivery_type", 2)
      }
    }
  }), _vm._v("\n                    店家送餐\n                  ")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.tableNumber.sub_delivery_type === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("桌號必填")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.is_table_no_required),
      expression: "tableNumber.is_table_no_required"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableNumber, "is_table_no_required", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("非必填")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("必填")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.tableNumber.sub_delivery_type === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                桌號編輯\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.is_table_no_editable),
      expression: "tableNumber.is_table_no_editable"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableNumber, "is_table_no_editable", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("不可編輯")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("可編輯")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.tableNumber.sub_delivery_type === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                桌號顯示\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumber.show_table_no),
      expression: "tableNumber.show_table_no"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableNumber, "show_table_no", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("顯示")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("隱藏")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                訪客下單\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, _vm._l((_vm.deliveryWaysInfo), function(deliveryWays, i) {
    return (deliveryWays.take_type === 21) ? _c('div', {
      key: i
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_allow_guest_order),
        expression: "deliveryWays.is_allow_guest_order"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(deliveryWays.is_allow_guest_order, 1)
      },
      on: {
        "change": function($event) {
          return _vm.$set(deliveryWays, "is_allow_guest_order", 1)
        }
      }
    }), _vm._v("\n                        開啟\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deliveryWays.is_allow_guest_order),
        expression: "deliveryWays.is_allow_guest_order"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": 0,
        "checked": _vm._q(deliveryWays.is_allow_guest_order, 0)
      },
      on: {
        "change": function($event) {
          return _vm.$set(deliveryWays, "is_allow_guest_order", 0)
        }
      }
    }), _vm._v("\n                        關閉\n                      ")])])]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _vm._l((_vm.deliveryWaysInfo), function(deliveryWays, i) {
    return (deliveryWays.take_type === 21 && deliveryWays.is_allow_guest_order === 1) ? _c('div', {
      key: i
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                預設登入方式\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tableNumber.default_login_type),
        expression: "tableNumber.default_login_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tableNumber, "default_login_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("會員")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2
      }
    }, [_vm._v("訪客")])])])]), _vm._v(" "), _c('br')]) : _vm._e()
  })], 2), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('h3', [_vm._v("排除設定")])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('p', [_vm._v("某時間(日期、星期、每月幾號)無法取餐(自取、外送、內用、桌邊掃碼)")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addExCalendar
    }
  }, [_vm._v("新增店家排除時段設定")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.exceptionCalendar), function(exCalendar, caIndex) {
    return _c('div', {
      staticClass: "m-t-10 process-time-block"
    }, [_c('div', {
      staticClass: "text-right m-b-10"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.exceptionCalendar, caIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("排除取餐類型")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exCalendar.delivery_type),
        expression: "exCalendar.delivery_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(exCalendar, "delivery_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.deliveryInfo), function(delivery) {
      return _c('option', {
        domProps: {
          "value": delivery.value
        }
      }, [_vm._v(_vm._s(delivery.label))])
    }), 0)])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addExDate(exCalendar)
        }
      }
    }, [_vm._v("加入指定日期")])]), _vm._v(" "), (exCalendar.date_type.length) ? _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(27, true), _vm._v(" "), _c('tbody', _vm._l((exCalendar.date_type), function(item, daIndex) {
      return _c('tr', [_c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.date),
          expression: "item.date"
        }],
        staticClass: "form-control inline-block",
        attrs: {
          "placeholder": "YYYY-MM-DD",
          "type": "text"
        },
        domProps: {
          "value": (item.date)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "date", $event.target.value)
          }
        }
      }), _vm._v("  \n              ")]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(exCalendar.date_type, daIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])])])
    }), 0)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addExWeekDay(exCalendar)
        }
      }
    }, [_vm._v("加入星期")])]), _vm._v(" "), (exCalendar.week_day.length) ? _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(28, true), _vm._v(" "), _c('tbody', _vm._l((exCalendar.week_day), function(item, weIndex) {
      return _c('tr', [_c('td', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.day),
          expression: "item.day"
        }],
        staticClass: "form-control",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(item, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.offdaySetting.options.weekDay), function(weekDay) {
        return (weekDay.value) ? _c('option', {
          domProps: {
            "value": weekDay.value
          }
        }, [_vm._v("\n                    " + _vm._s(weekDay.label) + "\n                  ")]) : _vm._e()
      }), 0)]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(exCalendar.week_day, weIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])])])
    }), 0)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "text-left"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.addExMonthDay(exCalendar)
        }
      }
    }, [_vm._v("加入每月幾號")])]), _vm._v(" "), (exCalendar.month_day.length) ? _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(29, true), _vm._v(" "), _c('tbody', _vm._l((exCalendar.month_day), function(item, moIndex) {
      return _c('tr', [_c('td', [_vm._v("\n                每月"), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.day),
          expression: "item.day"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "1-31",
          "type": "text"
        },
        domProps: {
          "value": (item.day)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "day", $event.target.value)
          }
        }
      }), _vm._v("  日\n              ")]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.start_time),
          expression: "item.start_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.start_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "start_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.end_time),
          expression: "item.end_time"
        }],
        staticClass: "form-control w-90 inline-block",
        attrs: {
          "placeholder": "hh:mm:ss",
          "type": "text"
        },
        domProps: {
          "value": (item.end_time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "end_time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            return _vm.removeListItem(exCalendar.month_day, moIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])])])
    }), 0)]) : _vm._e()])
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "pickupWarnModal",
    staticClass: "btn",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#pickupWarnModal"
    }
  }), _vm._v(" "), _vm._m(30)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 7),
      expression: "storeMethod === 7"
    }],
    staticClass: "box-body form"
  }, [_vm._m(31), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(32), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "overflow": "inherit"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(33), _vm._v(" "), _c('tbody', _vm._l((_vm.openingInfo), function(weekDay) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.getWeekDayName(weekDay.week_day)))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (weekDay.start),
        expression: "weekDay.start"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "hh:mm",
        "type": "text"
      },
      domProps: {
        "value": (weekDay.start)
      },
      on: {
        "blur": function($event) {
          return _vm.validateTimeRange(weekDay, 'start', 'end')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(weekDay, "start", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (weekDay.end),
        expression: "weekDay.end"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "hh:mm",
        "type": "text"
      },
      domProps: {
        "value": (weekDay.end)
      },
      on: {
        "blur": function($event) {
          return _vm.validateTimeRange(weekDay, 'start', 'end')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(weekDay, "end", $event.target.value)
        }
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addSpecialDay
    }
  }, [_vm._v("新增指定日期")])]), _vm._v(" "), (_vm.selectSpecialDay.length) ? _c('div', {
    staticClass: "m-t-10"
  }, [_vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _c('div', {
    staticClass: "table-responsive specialDayCalendarTable-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary sticky-header"
  }, [_c('tr', [_c('td', [_vm._v("指定日期")]), _vm._v(" "), _c('td', [_vm._v("營業時間")]), _vm._v(" "), _c('td', [_vm._v("打烊時間")]), _vm._v(" "), _c('td', [_vm._v("備註\n                  "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(36)], 1)]), _vm._v(" "), _c('td')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.selectSpecialDay), function(item, daIndex) {
    return _c('tr', [_c('td', {
      staticClass: "date-picker-cell"
    }, [_c('div', {
      staticClass: "calendar-container"
    }, [(item.showSpecialDayCalendar) ? _c('div', {
      staticClass: "calendar"
    }, [_c('FunctionalCalendar', {
      attrs: {
        "is-multiple-date-picker": true,
        "limits": _vm.calendarLimits
      },
      on: {
        "dayClicked": function($event) {
          return _vm.specialDayCalendarSelected(daIndex, $event)
        }
      },
      model: {
        value: (_vm.tempSpecialDayCalendar),
        callback: function($$v) {
          _vm.tempSpecialDayCalendar = $$v
        },
        expression: "tempSpecialDayCalendar"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "calenderClose"
    }, [_c('button', {
      staticClass: "btn btn-primary btn-xs btn-close",
      on: {
        "click": function($event) {
          item.showSpecialDayCalendar = false
        }
      }
    }, [_vm._v("\n                        關閉\n                      ")])])], 1) : _vm._e(), _vm._v(" "), _c('multiselect', {
      staticClass: "calendar-multiselect",
      attrs: {
        "tag-placeholder": "格式為YYYY-MM-DD",
        "placeholder": "新增日期 (格式為YYYY-MM-DD)",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.date,
        "multiple": true,
        "optionsLimit": 0,
        "hideSelected": true,
        "∂": ""
      },
      on: {
        "remove": function($event) {
          return _vm.removeTag('specialDay', daIndex, _vm.val)
        },
        "open": function($event) {
          return _vm.openSpecialDayCalendar(daIndex)
        }
      },
      model: {
        value: (item.calendar_list),
        callback: function($$v) {
          _vm.$set(item, "calendar_list", $$v)
        },
        expression: "item.calendar_list"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.start_time),
        expression: "item.start_time"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "hh:mm",
        "type": "text"
      },
      domProps: {
        "value": (item.start_time)
      },
      on: {
        "blur": function($event) {
          return _vm.validateTimeRange(item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "start_time", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.end_time),
        expression: "item.end_time"
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "hh:mm",
        "type": "text"
      },
      domProps: {
        "value": (item.end_time)
      },
      on: {
        "blur": function($event) {
          return _vm.validateTimeRange(item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "end_time", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "remark-cell"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "w-100-p form-control",
      attrs: {
        "rows": "1",
        "maxlength": _vm.specialDayRemarkMaxlength
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s((item.remark || '').length) + "/" + _vm._s(_vm.specialDayRemarkMaxlength))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.selectSpecialDay, daIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _vm._m(37), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType == 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            公休時間下單\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_off_allow_order),
      expression: "storeInfo.is_off_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isOffAllow"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.storeInfo.is_off_allow_order, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_off_allow_order", 1)
      }
    }
  }), _vm._v("可下單\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeInfo.is_off_allow_order),
      expression: "storeInfo.is_off_allow_order"
    }],
    attrs: {
      "type": "radio",
      "name": "isOffAllow"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.storeInfo.is_off_allow_order, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.storeInfo, "is_off_allow_order", 0)
      }
    }
  }), _vm._v("不可下單\n                  ")])])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              指定日期\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "calendar-container"
  }, [(_vm.showCalendar) ? _c('div', {
    staticClass: "calendar",
    on: {
      "blur": function($event) {
        _vm.showCalendar = false
      }
    }
  }, [_c('FunctionalCalendar', {
    attrs: {
      "is-multiple-date-picker": true,
      "limits": _vm.calendarLimits
    },
    on: {
      "dayClicked": _vm.calendarSelected
    },
    model: {
      value: (_vm.selectDate),
      callback: function($$v) {
        _vm.selectDate = $$v
      },
      expression: "selectDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calenderClose"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xs btn-close nd-ml-5",
    on: {
      "click": function($event) {
        _vm.showCalendar = false
      }
    }
  }, [_vm._v("\n                  關閉\n                ")])])], 1) : _vm._e(), _vm._v(" "), _c('multiselect', {
    staticClass: "calendar-multiselect",
    attrs: {
      "tag-placeholder": "格式為YYYY-MM-DD",
      "placeholder": "新增日期 (格式為YYYY-MM-DD)",
      "label": "label",
      "track-by": "value",
      "options": _vm.offdaySetting.options.date,
      "multiple": true,
      "optionsLimit": 0,
      "hideSelected": true
    },
    on: {
      "remove": function($event) {
        return _vm.removeTag('date', 0, $event)
      },
      "open": _vm.openDateCalendar
    },
    model: {
      value: (_vm.offdaySetting.date),
      callback: function($$v) {
        _vm.$set(_vm.offdaySetting, "date", $$v)
      },
      expression: "offdaySetting.date"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              每週幾\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "placeholder": "新增日期",
      "label": "label",
      "track-by": "value",
      "options": _vm.offdayWeekDayOptions,
      "multiple": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.offdaySetting.weekDay),
      callback: function($$v) {
        _vm.$set(_vm.offdaySetting, "weekDay", $$v)
      },
      expression: "offdaySetting.weekDay"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              每月幾號\n            ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "tag-placeholder": "數字為1~31",
      "placeholder": "新增日期 (格式為數字1~31)",
      "label": "label",
      "track-by": "value",
      "options": _vm.offdayMonthDayOptions,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addMonthDayTag
    },
    model: {
      value: (_vm.offdaySetting.monthDay),
      callback: function($$v) {
        _vm.$set(_vm.offdaySetting, "monthDay", $$v)
      },
      expression: "offdaySetting.monthDay"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 8),
      expression: "storeMethod === 8"
    }],
    staticClass: "box-body form"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('div', [_vm._m(38), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(39), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plasticSelect),
      expression: "plasticSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "plasticOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.plasticSelect, "1")
    },
    on: {
      "change": function($event) {
        _vm.plasticSelect = "1"
      }
    }
  }), _vm._v("開啟（此功能需於菜單上架塑膠袋商品方可支援）\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plasticSelect),
      expression: "plasticSelect"
    }],
    attrs: {
      "type": "radio",
      "name": "plasticOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.plasticSelect, "0")
    },
    on: {
      "change": function($event) {
        _vm.plasticSelect = "0"
      }
    }
  }), _vm._v("關閉\n                    ")])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                塑膠袋數量可自行調整\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text",
    domProps: {
      "textContent": _vm._s('消費者可否在購物車中自行調整塑膠袋的數量')
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plasticAmountAdjustable),
      expression: "plasticAmountAdjustable"
    }],
    attrs: {
      "type": "radio",
      "name": "plasticAmountAdjustable",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.plasticAmountAdjustable, "1")
    },
    on: {
      "change": function($event) {
        _vm.plasticAmountAdjustable = "1"
      }
    }
  }), _vm._v("開啟\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plasticAmountAdjustable),
      expression: "plasticAmountAdjustable"
    }],
    attrs: {
      "type": "radio",
      "name": "plasticAmountAdjustable",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.plasticAmountAdjustable, "0")
    },
    on: {
      "change": function($event) {
        _vm.plasticAmountAdjustable = "0"
      }
    }
  }), _vm._v("關閉\n                    ")])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                塑膠袋單位(幾份商品一個塑膠袋)\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number.trim",
      value: (_vm.storeInfo.plastic_unit),
      expression: "storeInfo.plastic_unit",
      modifiers: {
        "number": true,
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.storeInfo.plastic_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.storeInfo, "plastic_unit", _vm._n($event.target.value.trim()))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                預設勾選塑膠袋\n              ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "placeholder": "選擇取餐方式",
      "label": "label",
      "track-by": "value",
      "options": _vm.deliveryInfo,
      "multiple": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.deliveryWayPlastic),
      callback: function($$v) {
        _vm.deliveryWayPlastic = $$v
      },
      expression: "deliveryWayPlastic"
    }
  })], 1)]), _vm._v(" "), _c('br')])]) : _vm._e()]), _vm._v(" "), _c('shipping-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 9),
      expression: "storeMethod === 9"
    }],
    ref: "shipping",
    attrs: {
      "resetShopping": _vm.resetShopping
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 10),
      expression: "storeMethod === 10"
    }],
    staticClass: "box-body form"
  }, [_vm._m(40), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.printerStoreList.length) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(41), _vm._v(" "), _c('tbody', _vm._l((_vm.printerStoreList), function(printer, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n                  出單機" + _vm._s(printer.printer_id) + "號 (" + _vm._s(printer.printer_id) + ")\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(printer.binding_name) + " (" + _vm._s(printer.binding_id) + ")\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.printerType(printer.printer_type)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(printer.printer_identity))]), _vm._v(" "), _c('td', [(printer.printer_is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!printer.printer_is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")]) : _vm._e()]), _vm._v(" "), _c('td', [(printer.binding_is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!printer.binding_is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#editModal"
      },
      on: {
        "click": function($event) {
          return _vm.getCurrent(printer)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#delModal"
      },
      on: {
        "click": function($event) {
          return _vm.getCurrent(printer)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            方式\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerSelect),
      expression: "printerSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.printerSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("使用現有")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.printerSelect === 1) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            識別碼\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerInfo.identity),
      expression: "printerInfo.identity"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.printerInfo.identity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerInfo, "identity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.printerSelect === 1) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            類型\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerInfo.type),
      expression: "printerInfo.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.printerInfo, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("W牌出單機(1)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("F牌出單機(2)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("F牌貼紙機(3)")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.printerSelect === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            選擇出單機\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPrinterSelect),
      expression: "isPrinterSelect"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isPrinterSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.printerList), function(printer) {
    return _c('option', {
      domProps: {
        "value": printer.printer_id
      }
    }, [_vm._v(_vm._s(printer.printer_identity))])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 10) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkPrinter
    }
  }, [_vm._v("\n          綁定\n        ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr', {
    staticClass: "m-t-20"
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.printerLayoutSetting.length) ? _c('div', [_vm._m(42), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(43), _vm._v(" "), _c('tbody', _vm._l((_vm.printerLayoutSetting), function(printer, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(printer.layout_name) + "\n                  ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (printer.trigger_type),
        expression: "printer.trigger_type"
      }],
      attrs: {
        "type": "radio",
        "name": 'triggerType' + index
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(printer.trigger_type, 1)
      },
      on: {
        "change": function($event) {
          return _vm.$set(printer, "trigger_type", 1)
        }
      }
    }), _vm._v("手動\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (printer.trigger_type),
        expression: "printer.trigger_type"
      }],
      attrs: {
        "type": "radio",
        "name": 'triggerType' + index
      },
      domProps: {
        "value": 2,
        "checked": _vm._q(printer.trigger_type, 2)
      },
      on: {
        "change": function($event) {
          return _vm.$set(printer, "trigger_type", 2)
        }
      }
    }), _vm._v("自動\n                      ")])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (printer.is_enabled),
        expression: "printer.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "name": 'isEnable' + index
      },
      domProps: {
        "value": 1,
        "checked": _vm._q(printer.is_enabled, 1)
      },
      on: {
        "change": function($event) {
          return _vm.$set(printer, "is_enabled", 1)
        }
      }
    }), _vm._v("啟用\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (printer.is_enabled),
        expression: "printer.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "name": 'isEnable' + index
      },
      domProps: {
        "value": 0,
        "checked": _vm._q(printer.is_enabled, 0)
      },
      on: {
        "change": function($event) {
          return _vm.$set(printer, "is_enabled", 0)
        }
      }
    }), _vm._v("未啟用\n                      ")])])])])
  }), 0)]), _vm._v(" "), _c('br')])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 11 && _vm.$route.name !== 'crStore'),
      expression: "storeMethod === 11 && $route.name !== 'crStore'"
    }],
    staticClass: "box-body form"
  }, [_vm._m(44), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(45), _vm._v(" "), _c('div', {
    staticClass: "table-responsive m-b-15"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("入口")]), _vm._v(" "), _c('td', [_vm._v("桌號\n                  "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n                      限10字以內，僅限英數大小寫不可符號，桌號間請使用「，」分隔。\n                    ")])], 1)]), _vm._v(" "), _c('td')])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNumberUrl.type),
      expression: "tableNumberUrl.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableNumberUrl, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.enterType), function(item) {
    return _c('option', {
      key: ("enter-" + (item.value)),
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.tableNumberUrl.text),
      expression: "tableNumberUrl.text",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control inline-block",
    attrs: {
      "rows": "3",
      "placeholder": "範例：A01,A02,A03..."
    },
    domProps: {
      "value": (_vm.tableNumberUrl.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tableNumberUrl, "text", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": _vm.exportUrl
    }
  }, [_vm._v("匯出網址")])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 12),
      expression: "storeMethod === 12"
    }],
    staticClass: "box-body form"
  }, [_vm._m(46), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n              選擇計費方式\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCommissionSetting.type),
      expression: "orderCommissionSetting.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.orderCommissionSetting, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("系統費")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("系統費+資訊服務費抽成")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("資訊服務費抽成")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.orderCommissionSetting.type > 1) ? _c('div', {
    staticClass: "text-left"
  }, [_c('div', [_vm._m(47), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.orderCommissionSetting.item_list.push(JSON.parse(JSON.stringify(_vm.commissionItemList)))
      }
    }
  }, [_vm._v("\n              新增資訊服務費抽成設定\n            ")])]), _vm._v(" "), _vm._l((_vm.orderCommissionSetting.item_list), function(item, pIndex) {
    return _c('div', {
      key: pIndex,
      class: ['process-time-block', {
        'm-t-10': pIndex !== 0
      }, {
        'overlap': _vm.showOverlapErrorIndex.includes(pIndex)
      }]
    }, [_c('div', {
      staticClass: "text-right m-b-10"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.orderCommissionSetting.item_list, pIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(48, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.ratio),
        expression: "item.ratio"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "輸入數字",
        "type": "number",
        "maxlength": "2"
      },
      domProps: {
        "value": (item.ratio)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "ratio", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-addon-icon"
    }, [_vm._v("\n                  %\n                ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                  取貨方式\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.delivery_type),
        expression: "item.delivery_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "delivery_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.supportDeliveryOption), function(delivery) {
      return _c('option', {
        key: ("takeType" + (delivery.value)),
        domProps: {
          "value": delivery.value
        }
      }, [_vm._v("\n                      " + _vm._s(delivery.label) + "\n                    ")])
    })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "table-row"
    }, [_vm._m(49, true), _vm._v(" "), _c('div', {
      staticClass: "table-from"
    }, [_c('date-picker', {
      staticClass: "hide-date-icon",
      attrs: {
        "show-second": false,
        "type": "datetime",
        "valueType": "format",
        "format": "YYYY-MM-DD HH:mm",
        "input-class": "form-control",
        "placeholder": "新增日期 (格式為：YYYY-MM-DD HH:mm)",
        "clearable": false,
        "disabled-time": _vm.notBeforeTodayAddTwoMins,
        "disabled-date": _vm.notBeforeToday
      },
      model: {
        value: (item.start_time),
        callback: function($$v) {
          _vm.$set(item, "start_time", $$v)
        },
        expression: "item.start_time"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "table-row p-t-10"
    }, [_vm._m(50, true), _vm._v(" "), _c('div', {
      staticClass: "table-from"
    }, [_c('date-picker', {
      staticClass: "hide-date-icon",
      attrs: {
        "show-second": false,
        "type": "datetime",
        "valueType": "format",
        "format": "YYYY-MM-DD HH:mm",
        "input-class": "form-control",
        "placeholder": "新增日期 (格式為：YYYY-MM-DD HH:mm)",
        "clearable": false,
        "disabled-time": _vm.notBeforeTodayAddTwoMins,
        "disabled-date": _vm.notBeforeToday
      },
      model: {
        value: (item.end_time),
        callback: function($$v) {
          _vm.$set(item, "end_time", $$v)
        },
        expression: "item.end_time"
      }
    })], 1)])])])
  }), _vm._v(" "), _c('br')], 2) : _vm._e(), _vm._v(" "), (_vm.orderCommissionSetting.type !== 1) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(51), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCommissionSetting.has_independent_report),
      expression: "orderCommissionSetting.has_independent_report"
    }],
    attrs: {
      "type": "radio",
      "name": "independent"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.orderCommissionSetting.has_independent_report, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.orderCommissionSetting, "has_independent_report", 1)
      }
    }
  }), _vm._v("是\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCommissionSetting.has_independent_report),
      expression: "orderCommissionSetting.has_independent_report"
    }],
    attrs: {
      "type": "radio",
      "name": "independent"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.orderCommissionSetting.has_independent_report, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.orderCommissionSetting, "has_independent_report", 0)
      }
    }
  }), _vm._v("否\n                    ")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.orderCommissionSetting.has_independent_report === 1) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                門市每月作廢訂單額度(筆)\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCommissionSetting.allow_invalid_order_quota),
      expression: "orderCommissionSetting.allow_invalid_order_quota"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.orderCommissionSetting.allow_invalid_order_quota)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderCommissionSetting, "allow_invalid_order_quota", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.orderCommissionSetting.has_independent_report === 0) ? _c('div', [_vm._m(52), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(53), _vm._v(" "), _c('div', {
    staticClass: "flex align-center"
  }, [_c('span', {
    staticClass: "w-35 text-left m-l-15"
  }, [_vm._v(_vm._s(_vm.brandInvalidQuota))])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 13),
      expression: "storeMethod === 13"
    }],
    staticClass: "box-body form"
  }, [_vm._m(54), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(55), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.store_shipping_vendor), function(vendor, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n                  " + _vm._s(_vm._f("shippingVendorName")(vendor.vendor_code)) + "\n                ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (vendor.is_enable),
        expression: "vendor.is_enable"
      }],
      attrs: {
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(vendor.is_enable, "1")
      },
      on: {
        "input": _vm.setReload,
        "change": function($event) {
          return _vm.$set(vendor, "is_enable", "1")
        }
      }
    }), _vm._v("\n                        啟用\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (vendor.is_enable),
        expression: "vendor.is_enable"
      }],
      attrs: {
        "type": "radio",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(vendor.is_enable, "0")
      },
      on: {
        "input": _vm.setReload,
        "change": function($event) {
          return _vm.$set(vendor, "is_enable", "0")
        }
      }
    }), _vm._v("\n                        不啟用\n                      ")])])])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 15),
      expression: "storeMethod === 15"
    }],
    staticClass: "box-body form"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('div', [_vm._m(56), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(57), _vm._v(" "), _c('div', {
    staticClass: "flex align-center h-34"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.showTablewareStrawOption),
      expression: "showTablewareStrawOption",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "showTablewareStrawOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.showTablewareStrawOption, _vm._n("1"))
    },
    on: {
      "change": function($event) {
        _vm.showTablewareStrawOption = _vm._n("1")
      }
    }
  }), _vm._v("開啟\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.showTablewareStrawOption),
      expression: "showTablewareStrawOption",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "showTablewareStrawOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.showTablewareStrawOption, _vm._n("0"))
    },
    on: {
      "change": function($event) {
        _vm.showTablewareStrawOption = _vm._n("0")
      }
    }
  }), _vm._v("關閉\n                  ")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(58), _vm._v(" "), _c('div', {
    staticClass: "flex align-center h-34"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.setTablewareStrawDefaultVal),
      expression: "setTablewareStrawDefaultVal",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "setTablewareStrawDefaultVal",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.setTablewareStrawDefaultVal, _vm._n("1"))
    },
    on: {
      "change": function($event) {
        _vm.setTablewareStrawDefaultVal = _vm._n("1")
      }
    }
  }), _vm._v("開啟\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.setTablewareStrawDefaultVal),
      expression: "setTablewareStrawDefaultVal",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "setTablewareStrawDefaultVal",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.setTablewareStrawDefaultVal, _vm._n("0"))
    },
    on: {
      "change": function($event) {
        _vm.setTablewareStrawDefaultVal = _vm._n("0")
      }
    }
  }), _vm._v("關閉\n                  ")])])])]), _vm._v(" "), _c('br')])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pb-10"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.goToStoreTable
    }
  }, [_vm._v("\n        取消\n      ")]), _vm._v(" "), _c('button', {
    ref: "modal",
    staticClass: "btn btn-success",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#selectStoreModal"
    }
  }, [_vm._v("\n        完成並選擇門市\n      ")])]), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.reCheckOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.updateOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.editOption,
      "selectChange": _vm.selectChange,
      "selectOptions": _vm.selectOptions
    },
    on: {
      "trigger": _vm.trigger,
      "selectOnChange": _vm.selectOnChange,
      "inputOnChange": _vm.inputOnChange
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "selectStoreModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content p-a-0"
  }, [_vm._m(59), _vm._v(" "), _c('div', {
    staticClass: "modal-body pa-20"
  }, [_c('div', [_vm._v("請選取所有欲套用設定的門市至右側「套用門市」區塊，按下「確認變更」後指定的變更項目將覆蓋門市原有設定並立即套用。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "form-group mr-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.statusSelect),
      expression: "form.statusSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "statusSelect", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.statusTypeList), function(type, index) {
    return _c('option', {
      key: ("option-" + index),
      domProps: {
        "value": type.value
      }
    }, [_vm._v("\n                " + _vm._s(type.label) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group mr-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.orderStatusSelect),
      expression: "form.orderStatusSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "orderStatusSelect", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 99
    }
  }, [_vm._v("== 接單狀態 ==")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("接單中")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 20
    }
  }, [_vm._v("不接單")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.isSearchSelect),
      expression: "form.isSearchSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "isSearchSelect", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 99
    }
  }, [_vm._v("== 搜尋狀態 ==")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("可搜尋")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("不可搜尋")])])])]), _vm._v(" "), _vm._m(60), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.includeStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "display": "flex",
      "justify-content": "end"
    }
  }, [_c('button', {
    staticClass: "btn btn-default bt-c",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    ref: "modal",
    staticClass: "btn btn-default bt-c",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "data-toggle": "modal",
      "data-target": "#updateModal"
    }
  }, [_vm._v("確認變更")]), _vm._v(" "), _c('button', {
    ref: "modal",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "reCheckButton",
      "type": "button",
      "data-dismiss": "modal",
      "data-toggle": "modal",
      "data-target": "#reCheckModal"
    }
  }, [_vm._v("顯示錯誤")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-20"
  }, [_c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("請輸入/選取需批次變更的項目，指定的變更項目會一鍵套用在所有選擇的門市中，並覆蓋門市原有的設定。")]), _vm._v(" "), _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("不同分頁設定項目需分次操作。")]), _vm._v(" "), _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("無需變更的項目請維持空白，套用變更時，空白項目將維持門市原有的設定。")]), _vm._v(" "), _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("若無需變更的項目誤選取到，可按右方的「清空此頁面設定」按鈕清除（不會變更門市原有的設定）。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n                  選擇\"清空現有店家公告\"將會"), _c('br'), _vm._v("清除套用門市的原有公告。\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(圖片大小為200x200)"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(圖片大小為800x460)"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("細部設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("貼紙限制字數\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("門市下訂金額限制")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("菜單呈現設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("預訂設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("接單/送單設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("付款方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    前台顯示畫面，如下方粉色備註區塊\n                    "), _c('img', {
    attrs: {
      "src": "/static/img/trade_remark_ex.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("現金付款設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐方式")]), _vm._v(" "), _c('td', [_vm._v("付款順序")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("付款方式與取餐金額")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐方式")]), _vm._v(" "), _c('td', [_vm._v("付款方式")]), _vm._v(" "), _c('td', [_vm._v("起始金額")]), _vm._v(" "), _c('td', [_vm._v("結束金額")]), _vm._v(" "), _c('td', [_vm._v("描述")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("製作/取餐時間")]), _vm._v(" "), _c('div', [_vm._v("\n            準備時間需設定 3 分鐘以上，取餐時間間隔需設定 10 的倍數\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 各列設定為群組功能，需將取餐類型的\"準備時間+取餐時間間隔\"一併設定後才可進行修改。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐類型")]), _vm._v(" "), _c('td', [_vm._v("準備時間")]), _vm._v(" "), _c('td', [_vm._v("取餐時間間隔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td', [_vm._v("準備時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("取餐方式/門檻")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 外送的\"消費金額與距離門檻\"設定為群組功能，需將每個級距規則一併設定後才可進行修改。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 於單一門市資訊已設為預設的取餐方式，不可於此處設定為關閉，該門市關閉設定將不被覆蓋。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 當門市的取餐類型為\"不支援\"時，若在此設定為開啟，該門市開啟狀態將維持關閉。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text text-align-left"
  }, [_vm._v("\n                    ．計算商品金額 (折扣後) ，不含塑膠袋。"), _c('br'), _vm._v("\n                    ．0元為最低消費金額\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    顯示在購物車頁面上，消費者可查看，前台顯示畫面，如下方粉色備註區塊\n                    "), _c('img', {
    attrs: {
      "alt": "備註描述圖片",
      "src": "/static/img/delivery_memo_ex.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    顯示在訂單確認頁面上，消費者可查看，如預覽圖所示。\n                    "), _c('img', {
    attrs: {
      "alt": "取餐提醒圖片",
      "src": "/static/img/delivery_pickup_memo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("指定日期")]), _vm._v(" "), _c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("星期")]), _vm._v(" "), _c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("每月幾號")]), _vm._v(" "), _c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade text-left",
    attrs: {
      "role": "dialog",
      "id": "pickupWarnModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("提醒")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n                預設項目不可關閉，請先調整預設的取餐類型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("確定")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("營業時間")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 各列設定為群組功能，需將每個星期的的\"營業時間+打烊時間\"一併設定後才可進行修改。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("星期")]), _vm._v(" "), _c('td', [_vm._v("營業時間")]), _vm._v(" "), _c('td', [_vm._v("打烊時間")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 設定完成後，指定日期將套用此營業時間顯示，期間結束後即恢復預設營業時間。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 若與公休日期重複，會優先顯示指定日期的營業時間。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n                    顯示在前台門市營業時間後方，如下範例："), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/specialDay_remark_tooltips.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("公休時間")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("塑膠袋設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                塑膠袋功能\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text alliance-tooltip"
  }, [_vm._v("\n                    「 塑膠袋功能 」將顯示於購車第一步驟，提供消費者選擇。\n                    "), _c('img', {
    attrs: {
      "src": "/static/img/plastic-select-sample-img.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("出單機設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("出單機名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("辨識碼")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("出單機啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定機啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("出單機列印格式設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("列印格式")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("觸發類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("網址設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 若開啟內用-桌邊掃碼取餐類型，門市可利用網址設定功能，新增桌號並獲取各桌獨立網址，將該網址轉為QRCode後即可運用於提供給顧客做桌邊掃碼點餐。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("計費方式設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("新增資訊服務費抽成設定為群組功能，無法單獨設定。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  資訊服務費抽成%\n                  "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "請勿輸入空格"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_vm._v("\n                  抽成生效日\n                  "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "系統依據該日期開始計算到資訊服務費抽成報表"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell"
  }, [_vm._v("\n                  抽成結束日\n                  "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "系統依據該日期停止計算到資訊服務費抽成報表"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                門市獨立產出抽成對帳表/計算作廢額度\n                "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "適用於門市獨立簽約的類型"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("可至「編輯品牌」調整作廢訂單額度。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                每月作廢訂單額度(筆)\n                "), _c('span', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "此為整個品牌的作廢訂單總額度，非單一門市；若修改會同步更新其他門市此欄位值"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("物流設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("配送物流")]), _vm._v(" "), _c('td', [_vm._v("開啟狀態")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("特殊需求")]), _vm._v(" "), _c('div', [_vm._v("請確認POS端是否支援此功能")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                自選吸管或餐具功能\n                "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text alliance-tooltip"
  }, [_vm._v("\n                    「 自選吸管或餐具功能 」 將顯示於購車第一步驟，提供消費者選擇。\n                    "), _c('img', {
    attrs: {
      "src": "/static/img/straw-option-sample-img.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("預設吸管或餐具選項\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header border-bottom pa-20"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("批次門市設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex text-blod"
  }, [_c('h5', {
    staticStyle: {
      "width": "315px"
    }
  }, [_vm._v("不套用門市")]), _vm._v(" "), _c('h5', [_vm._v("套用門市")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67eb4c39"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Brand/BatchSetupStore.vue
// module id = 2464
// module chunks = 1